let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useIsPillBorderRadius } from '../hooks/useIsPillBorderRadius';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalPopoverOverrides = createGlobalStyle(_t || (_t = _`
  [data-component-name="UIPopover"] {
    border-radius: ${0} !important;
  }
`), ({
  theme,
  $isUsingPillBorderRadius
}) => $isUsingPillBorderRadius ? theme.borderRadius['0'] : theme.borderRadius['300']);
export const GlobalPopoverStyles = () => {
  const isPill = useIsPillBorderRadius();
  return /*#__PURE__*/_jsx(StyledGlobalPopoverOverrides, {
    $isUsingPillBorderRadius: isPill
  });
};